import axiosInstance from 'api/axiosInstance';
import dayjs from 'dayjs';
import { stringify } from 'query-string';
import type { Period } from 'types/global.types';
import type { Invoice, InvoiceType } from 'types/invoice.types';
import { onCreateInvoiceGTM } from 'utils/GTM';
import { FIVE_MINUTES } from 'utils/time';

export const createRevenue = (filename: string, revenueType: InvoiceType) => {
  return axiosInstance
    .post<any, Promise<Invoice>>(
      `/v1/invoices/dropzone-import?cache=${Date.now()}`,
      { filename, revenueType },
      {
        timeout: FIVE_MINUTES,
      },
    )
    .then((data) => {
      onCreateInvoiceGTM();
      return data;
    });
};

export const getCurrentYearIncomeAmount = (): Promise<{
  amount: number;
}> => {
  const query = {
    year: dayjs().year(),
    endDate: dayjs().format('YYYY-MM-DD'),
  };
  return axiosInstance.get(
    `/v1/calculations/invoices/income?${stringify(query)}`,
  );
};

export const getCurrentPeriodIncomeAmount = (
  params: Period & { endDate: string },
): Promise<{
  amount: number;
}> => {
  return axiosInstance.get(
    `/v1/calculations/invoices/income?${stringify(params)}`,
  );
};
